import {Drivers, Storage} from "@ionic/storage";
import {getManager} from "./Manager";
import {IAnyObject} from "../common/SimpleInterface";
import {isArray} from "../common/SiteHelper";

export type StorageName =
    "app_storage" |
    "config" |
    "file" |
    "data_model";


export default class StorageManager
{

    storages:IStorages = {};
    defaultStorageName:StorageName = "app_storage";

    constructor()
    {

    }

    async requireStorage(storageName?:StorageName): Promise<Storage>
    {
        storageName = storageName ? storageName : this.defaultStorageName;
        if(this.storages[storageName]){
            return this.storages[storageName];
        }
        const storage = new Storage({
            name: storageName,
            driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
        });

        return storage.create().then(s => {
            if(!this.storages[storageName]){
                this.storages[storageName] = storage;
            }
            return this.storages[storageName];
        });
    }

    async set(key:string, value: any, storageName?:StorageName): Promise<Storage>
    {
        return this.requireStorage(storageName).then(storage => storage.set(key, value).then(_ =>
        {
            return storage
        }));
    }

    async get(key: string, storageName?: StorageName)
    {
        let storage = await this.requireStorage(storageName);
        return storage.get(key)
    }

    async getAll(storageName?: StorageName): Promise<IAnyObject>
    {
        let storage = await getManager().storage.requireStorage(storageName);
        return storage.keys()
            .then(async keys =>
            {
                const mapped = await Promise.all(keys.map(k => storage.get(k)));
                const object: IAnyObject = {};
                if (isArray(mapped))
                {
                    for (let i = 0; i < Math.min(keys.length, mapped.length); i++)
                    {
                        object[keys[i]] = mapped[i];
                    }
                }
                return object;
            });
    }

    async remove(key: string, storageName?: StorageName)
    {
        let storage = await this.requireStorage(storageName);
        return storage.remove(key)
    }

    async clear(storageName: StorageName)
    {
        let storage = await this.requireStorage(storageName);
        delete this.storages[storageName];
        return storage.clear()
    }
}

export interface IStorages
{
    [key: string]: Storage;
}